export const TRANSFORMATION_ICON_FILENAME_MAP: Record<string, string> = {
    aggregation: 'Aggregation.svg',
    aggreagation: 'Aggregation.svg',
    boxcox: 'box cox.svg',
    columnreplace: 'column_replace.svg',
    concat: 'Concatenation.svg',
    cumulative: 'cumulative.svg',
    datatypeconversion: 'data_type_conversion.svg',
    datesplit: 'date split.svg',
    datetointeger: 'date to integer.svg',
    derivedcolumn: 'Derived Column.svg',
    dropduplicate: 'drop duplicate.svg',
    dropduplicates: 'drop duplicate.svg',
    dropfields: 'drop fields.svg',
    droprows: 'drop rows.svg',
    filter: 'filter.svg',
    forwardfill: 'forward fill.svg',
    lettercase: 'lettercase.svg',
    caseset: 'lettercase.svg',
    casechange: 'lettercase.svg',
    lookup: 'look up.svg',
    renamecolumns: 'rename columns.svg',
    replacemapping: 'replace mapping.svg',
    replacenulls: 'replace nulls.svg',
    searchreplace: 'search&replace.svg',
    findandreplace: 'search&replace.svg',
    sorting: 'sorting.svg',
    sort: 'sorting.svg',
    sortfields: 'sorting.svg',
    sortcolumns: 'sorting.svg',
    split: 'split.svg',
    transpose: 'transpose.svg',
    udftransformation: 'UDF Transformation.svg',
    udf: 'UDF Transformation.svg',
    zscore: 'z score.svg',
}

export function getTransformationIconSrc(value: string): string | undefined {
    const normalized = value.trim().toLowerCase().replace(/[^a-z0-9]+/g, '')
    const filename = TRANSFORMATION_ICON_FILENAME_MAP[normalized]
    return filename ? `/assets/transformations/${filename}` : undefined
}

export const INTEGRATION_ITEMS: { id: string; label: string; icon: string }[] = [
    { id: 'union', label: 'Union', icon: 'merge' },
    { id: 'join', label: 'Join', icon: 'join_full' },
]
